var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 755,
    viewBox: "0 0 755 755",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.111 24.9968C441.061 11.1915 455.554 2.833 469.481 6.32768L729.781 71.6413C743.709 75.136 751.797 89.1604 747.847 102.966L614.843 567.79C610.893 581.596 596.4 589.954 582.472 586.459L322.172 521.146C308.245 517.651 300.156 503.627 304.107 489.821L437.111 24.9968Z",
    fill: "#5177FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1599_993",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 303,
    y: 5,
    width: 446,
    height: 583
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.11 24.9968C441.061 11.1915 455.554 2.833 469.481 6.32768L729.781 71.6413C743.709 75.136 751.797 89.1604 747.847 102.966L614.843 567.79C610.893 581.596 596.4 589.954 582.472 586.459L322.172 521.146C308.245 517.651 300.156 503.627 304.106 489.821L437.11 24.9968Z",
    fill: "#5177FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1599_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.5 591.5L354.508 528.965L441.382 239.519L588.5 591.5Z",
    fill: "#2D48AB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.157 187.203C144.107 173.398 158.6 165.04 172.527 168.534L432.827 233.848C446.755 237.343 454.843 251.367 450.893 265.172L317.889 729.997C313.939 743.802 299.446 752.161 285.518 748.666L25.2183 683.352C11.2907 679.858 3.20235 665.833 7.15259 652.028L140.157 187.203Z",
    fill: "#FF511B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.a371a564b0ecbc2953958ac38a6385fe.svg";
export { ForwardRef as ReactComponent };